import { Container, Nav, Navbar } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Administrator } from "../../services/models/administrator";
import NavBarLoggedInView from "./NavBarLoggedInView";
import NavBarLoggedOutView from "./NavBarLoggedOutView";
import s from "../../assets/styles/NavBar.module.css";
import { SubUser } from "../../services/models/sub_user";
import logo from "../../assets/img/logo.svg";
import * as AdministratorsApi from "../../services/network/administrator-api";
import {LogoutButton} from "./LogoutButton";

interface NavBarProps {
    loggedInUser: Administrator | SubUser | null
    onLogoutSuccessful: () => void,
}
function isAdministrator(obj: any): obj is Administrator {
    return obj && obj.role === undefined
}

const NavBar = ({loggedInUser, onLogoutSuccessful}: NavBarProps) => {
    const homeLink = loggedInUser 
        ? (isAdministrator(loggedInUser) ? "/administrator/cabinet" : "/user/cabinet") 
        : "/";

    let navigate = useNavigate();
    const queryClient = useQueryClient();
    const routeChange = (path: string) => {
        navigate(path);
    }
    async function logout() {
        try {
            await AdministratorsApi.logout();
            // Очищаем весь кэш React Query
            queryClient.clear();
            onLogoutSuccessful();
            routeChange("/");
        } catch (error) {
            console.error(error);
            alert(error);
        }
    }
    return (
        <Navbar className={s.navbarNew}>
            <Container className={s.navBarContainer}>
                <Navbar.Brand as={Link} to={homeLink} className={s.navbarLogoWrapper}>
                    <img src={logo} alt="Лого" title="Лого" className={s.navbarLogo}/>
                    <p className={s.navbarLogoName}>НМИЦ ИТ</p>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="main-navbar" />
                <Navbar.Collapse id="main-navbar">
                    <Nav className="ms-auto">
                            { loggedInUser
                                ? <NavBarLoggedInView isAdmin={isAdministrator(loggedInUser)} homeLink={homeLink} user={loggedInUser}/>
                                : <NavBarLoggedOutView/>
                            }
                    </Nav>
                </Navbar.Collapse>
                { loggedInUser && (
                    <Navbar.Collapse id="logout-navbar">
                        <Nav className="ms-auto">
                            <LogoutButton logoutHandler={logout}/>
                        </Nav>
                    </Navbar.Collapse>
                )}
            </Container>
        </Navbar>
    );
}

export default NavBar;